<template>
    <div class="content">
        <div v-if="page === 'login'">
            <div class="close" @click="jump('/')"><i class="iconfont icon-a-close-line1"></i></div>
            <div class="signin" style="margin-bottom:20px">
                <h4>{{ $t('Home.Login.SignIn') }}</h4>
                <!-- <p>{{ $t('Home.Mobile.Login.Account') }} <router-link class="register" to="/register">{{ $t('Home.Register.SignUp') }}</router-link></p> -->
            </div>

            <div>
                <div v-if="loginMethod === 'email'" class="username">
                    <el-input v-model.trim="username" autocomplete="off" :placeholder="$t('Home.Login.EmailID')" class="email" @input="checkBtn"></el-input>
                </div>
                <div v-else class="username">
                    <van-popup v-model="showPicker" position="bottom">
                        <van-picker show-toolbar :columns="areaCodeList" @confirm="checkAreaCode" @cancel="showPicker = false" cancel-button-text="Cancel" confirm-button-text="Confirm"/>
                    </van-popup>
                    <div class="login-mobile f--c">
                        <div style="position: relative;">
                            <el-input v-model.trim="areaCode" class="areaCode" readonly="readonly" @click.native="selectAreaCode"></el-input>
                            <i class="el-icon-arrow-down"  @click="selectAreaCode" style="top: 17px; right: 8px; left: unset;"></i>
                        </div>
                        <el-input v-model.trim="username" :placeholder="$t('Home.Mobile.Login.PhoneNumber')" class="phone" @input="checkPhone" />
                    </div>
                </div>
                <input ref="username" type="hidden" />
                <div class="password">
                    <el-input type="password" ref="password" v-model.trim="password" show-password :placeholder="$t('Home.Mobile.Login.Password')" @input="checkBtn" style="width:90%;" />
                </div>
                <div class="remember">
                    <div style="width: 90%; display: inline-block;">
                        <el-checkbox v-model="rememberMe" style="float: left;  color: #909399;">{{ $t('Home.Login.RememberMe') }}</el-checkbox>
                        <span class="forgetPwd" @click="forgetPwd">{{$t('Home.Mobile.Login.ForgetYourPassword')}}</span>
                    </div>
                </div>
                <div class="login-btn">
                    <el-button :loading="loadingBtn" ref="loginBtn" type="primary" @click="handleLogin" :disabled="loginBtn">{{ $t('Home.Login.SignIn') }} <i class="el-icon-right"></i></el-button>
                </div>
            </div>

            <div class="login-method">
                <el-divider class="login-method-or">or</el-divider>
                <div class="login-method-img">
                    <img src="https://img.kakaclo.com/web-img/home/login/icon_1.png" v-if="loginMethod === 'email'" @click="changeLoginMethod('phone')">
                    <img src="https://img.kakaclo.com/web-img/home/login/icon_3.png" v-else @click="changeLoginMethod('email')">
                    <el-button class="btn" style="position: relative; display: inline-block;" data-onsuccess="googleLoginSuccessCb">
                        <img src="https://img.kakaclo.com/web-img/home/login/icon_2.png" alt="" data-onsuccess="googleLoginSuccessCb"  @click="handleClick">
                        <div class="g-signin2" data-onsuccess="googleLoginSuccessCb"  @click="handleClick" style="position: absolute; opacity:0; top: 8px; left: 8px;"></div>
                    </el-button>
                </div>
            </div>

            <div class="popup" v-if="popupShow">
                <div class="popup-mask" @click="popupShow = false"></div>
                <div class="popup-dialog">
                    <div class="popup-title">{{ $t('Home.Mobile.Login.LoginFailed') }}</div>
                    <div class="popup-content">{{ loginFailed }}</div>
                    <div class="popup-submit" @click="popupShow = false">{{ $t('Home.Mobile.Login.Confirm') }}</div>
                </div>
            </div>
        </div>
        <div v-else-if="page==='reset'">
            <div class="return">
                <span><img @click="page='login'" src="@/assets/img/return.png"></span>
            </div>
            <div class="signin">
                <p style="font-size: 20px; font-weight: 600; color: #303133;">Reset Your Password</p>
            </div>

            <div>
                <div v-if="returnMethod === 'email'" class="username">
                    <el-input v-model.trim="username" :placeholder="$t('Home.Login.EmailID')" class="email" @input="checkResetBtn"></el-input>
                </div>
                <div v-else class="username">
                    <van-popup v-model="showPicker" position="bottom">
                        <van-picker show-toolbar :columns="areaCodeList" @confirm="checkAreaCode" @cancel="showPicker = false" cancel-button-text="Cancel" confirm-button-text="Confirm"/>
                    </van-popup>
                    <div class="login-mobile f--c">
                        <div style="position: relative;">
                            <el-input v-model.trim="areaCode" class="areaCode" readonly="readonly" @click.native="selectAreaCode"></el-input>
                            <i class="el-icon-arrow-down"  @click="selectAreaCode" style="top: 17px; right: 8px; left: unset;"></i>
                        </div>
                        <el-input v-model.trim="username" :placeholder="$t('Home.Mobile.Login.PhoneNumber')" class="phone" @input="checkResetPhone"></el-input>
                    </div>
                </div>
                <div class="captcha">
                    <div style="width: 90%; display: inline-block;">
                        <el-input v-model.trim="captcha" @input="checkResetBtn" :placeholder="$t('Home.Mobile.Login.PleaseInputVerificationCode')" style="width:75%; float: left;"></el-input>
                        <el-button v-if="seconds===0" class="send" @click="send" :loading="loadingSendBtn" :disabled="sendBtn">{{ $t('Home.Mobile.Login.Send') }}</el-button>
                        <el-button v-else class="send" :disabled="sendBtn">{{seconds}}S</el-button>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                <div class="login-btn">
                    <el-button :loading="loadingBtn" type="primary" @click="checkVerificationCode" :disabled="continueBtn">{{ $t('Home.Mobile.Login.Continue') }}</el-button>
                </div>

                <div class="emailPwd" @click="changeReturnMethod">{{ $t('Home.Mobile.Login.ResetPasswordUsingEmailAddress') }}</div>
            </div>
        </div>
        <div v-else-if="page==='password'">
            <div class="return">
                <span><img @click="page='reset'" src="@/assets/img/return.png"></span>
            </div>
            <div class="signin">
                <p style="font-size: 20px; font-weight: 600; color: #303133;">Reset Your Password</p>
            </div>

            <div>
                <div class="password">
                    <div style="width: 90%; display: inline-block; margin-bottom: 24px;">
                        <el-input type="password" show-password v-model.trim="password" @input="checkPwdInput" :placeholder="$t('Home.Mobile.Login.PleaseInputNewCode')"></el-input>
                    </div>
                    <div style="width: 90%; display: inline-block;">
                        <el-input type="password" show-password v-model.trim="new_password" @input="checkPwdInput" :placeholder="$t('Home.Mobile.Login.PleaseConfirmPassword')"></el-input>
                        <p style="text-align: left;  margin-top: 8px; color: #909399; font-size: 12px;">{{ $t('Home.Mobile.Login.PasswordNotice') }}</p>
                    </div>
                </div>
                <div class="login-btn">
                    <el-button :loading="loadingBtn" type="primary" @click="handleModifyPassword" :disabled="continueBtn">{{ $t('Home.Mobile.Login.Continue') }}</el-button>
                </div>
            </div>
        </div>
        <div v-if="page==='password'" class="emailPwd" @click="page='reset'">{{ $t('Home.Mobile.Login.ResetPasswordUsingEmailAddress') }}</div>
    </div>

</template>

<script>
import API from '@/api'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import picker from 'vant/lib/picker'
import 'vant/lib/picker/style'
import LoginMethod from './components/LoginMethod.vue'

import { encrypt, decrypt } from '@/util/encryp.js'
import googleLoginMixin from '../js/googleLogin.js'

export default ({
  components: { 'van-popup': popup, 'van-picker': picker, LoginMethod },
  mixins: [googleLoginMixin],
  props: {
    areaCodeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      username: localStorage.getItem('remeberPassword') ? JSON.parse(localStorage.getItem('remeberPassword')).name : '',
      password: localStorage.getItem('remeberPassword') ? decrypt(JSON.parse(localStorage.getItem('remeberPassword')).pwd) : '',
      new_password: '',
      areaCode: localStorage.getItem('remeberPassword') ? JSON.parse(localStorage.getItem('remeberPassword')).code === undefined ? '+1' : JSON.parse(localStorage.getItem('remeberPassword')).code : '+1',
      loginMethod: localStorage.getItem('remeberPassword') ? JSON.parse(localStorage.getItem('remeberPassword')).type : 'email',
      returnMethod: 'email',
      showPicker: false,
      // areaCodeList: [],
      rememberMe: true,
      loadingBtn: false,
      loadingSendBtn: false,
      loginBtn: true,
      continueBtn: true,
      sendBtn: false,
      loginFailed: '',
      popupShow: false,
      page: 'login',
      captcha: '',
      seconds: 0
    }
  },
  created() {
    // this.checkBtn()
    // this.systemAddressInfo()
    console.log(JSON.parse(localStorage.getItem('remeberPassword')))
  },
  mounted() {
    this.checkBtn()
  },
  methods: {
    checkPhone() {
      this.username = this.username.replace(/\D/g, '')
      this.checkBtn()
    },
    checkBtn() { // 检测按钮是否可点
      this.loginBtn = !(this.username && this.password)
    },
    checkResetPhone() {
      this.username = this.username.replace(/\D/g, '')
      this.checkResetBtn()
    },
    checkResetBtn() {
      this.continueBtn = !(this.username && this.captcha)
    },
    checkPwdInput() {
      this.continueBtn = !(this.password && this.new_password)
    },
    checkAreaCode(v) {
      this.areaCode = v
      this.showPicker = false
    },
    selectAreaCode() {
      this.showPicker = true
    },
    systemAddressInfo() {
      API.systemAddressInfo().then(res => {
        let code = []
        res.data.forEach(function(v) {
          code.push(v.areaCode)
        })
        this.areaCodeList = code
      })
    },
    handleLogin() {
      this.login()
    },
    changeLoginMethod(method, type) {
      this.loginMethod = method
      this.username = ''
      this.password = ''
      this.loginBtn = true
    },
    login() {
      let data = new FormData()
      data.append('grant_type', 'password')
      data.append('client_id', 'client_general')
      data.append('client_secret', 'genera_secret')
      data.append('type', this.loginMethod)
      data.append('password', encrypt(this.password))

      if (this.loginMethod === 'email') {
        data.append('username', this.username)
      } else {
        data.append('username', this.areaCode + ' ' + this.username)
      }
      this.rememberMe ? this.setUserInfo() : this.clearUserInfo()
      this.loadingBtn = true

      API.login(data).then(this.loginSuccessCb).catch(result => {
        this.loginFailed = result.data.message
        this.popupShow = true
      }).finally(() => {
        this.loadingBtn = false
      })
    },
    // 清除UserInfo
    clearUserInfo() {
      localStorage.removeItem('remeberPassword')
    },
    setUserInfo() {
      let userinfo = {
        name: this.username,
        pwd: encrypt(this.password),
        type: this.loginMethod,
        code: this.areaCode
      }
      localStorage.setItem('remeberPassword', JSON.stringify(userinfo))
    },
    // 切换找回密码
    changeReturnMethod() {
      this.returnMethod = this.returnMethod === 'phone' ? 'email' : 'phone'
      this.username = ''
      this.captcha = ''
    },
    // 发送验证码
    send() {
      if (this.username === '') return this.$message.error(this.$t('promptText.msg26'))
      this.loadingSendBtn = true
      let params = this.returnMethod === 'phone' ? { phone: this.areaCode + ' ' + this.username } : { email: this.username }
      API.sendVertificationCode(params).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.sendBtn = true
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.sendBtn = false
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.sendBtn = false
        this.loadingSendBtn = false
      }).finally(() => {
        this.loadingSendBtn = false
      })
    },

    // 验证验证码是否正确
    checkVerificationCode() {
      this.loadingBtn = true
      let form = {
        verificationCode: this.captcha
      }
      this.returnMethod === 'phone' ? form.phone = this.areaCode + ' ' + this.username : form.email = this.username
      API.checkVerificationCode(form).then(res => {
        this.loadingBtn = false
        if (res.code !== 10000) return this.$message.error(res.message)
        this.page = 'password'
        this.password = ''
        this.new_password = ''
      }).catch(result => {
        this.loadingBtn = false
        return this.$message.error(result.data.message)
      })
    },

    // 重置密码
    handleModifyPassword() {
      if (this.password !== this.new_password) return this.$message.error(this.$t('Home.Mobile.Login.ConfirmPassword'))
      this.loadingBtn = true
      let form = { password: encrypt(this.password) }
      this.returnMethod === 'phone' ? form.phone = this.areaCode + ' ' + this.username : form.email = this.username

      API.handleModifyPassword(form).then(res => {
        this.loadingBtn = false
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('promptText.msg27'))
        this.page = 'login'
        this.captcha = ''
        let userinfo = {
          name: this.returnMethod === 'phone' ? this.areaCode + ' ' + this.username : this.username,
          pwd: encrypt(this.password),
          type: this.loginMethod,
          code: this.areaCode
        }
        localStorage.setItem('remeberPassword', JSON.stringify(userinfo))
        this.$router.replace({
          path: '/login',
          name: '/login'
        })
      }).catch(result => {
        this.loadingBtn = false
        this.$message.error(result.data.message)
      })
    },

    forgetPwd() {
      this.page = 'reset'
      this.returnMethod = this.loginMethod
    },

    handleClick() {
      this.isClickGoogle = true
      this.$emit('clickGoogle')
    },
    jump(path) {
      location.href = path
    }

  }
})
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: calc(100vh - 0.86rem);

    .close {
        height: 48px;
        line-height: 48px;
        text-align: right;
        padding-right: 24px;
        i, i:active {
            font-size: 24px;
            color: #303133;
            display: inline-block;
        }
    }
    .close span {
        cursor: pointer;
        color: #303133;
        font-size: 16px;
    }
    .return {
        text-align: center;
        span {
            display: inline-block;
            width: 90%;
            text-align: left;
            margin: 24px 0;
            img {
                width: 24px;
                cursor: pointer;
            }
        }
    }
    .signin {
        text-align: center;
        font-weight: 400;
        font-size: 14px;
    }
    .signin h4 {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        padding: 24px 0;
    }
    .signin p {
        color: #909399;
        padding-bottom: 24px;
    }
    .register {
        color: #9AC331;
    }
    .username {
        display: flex;
        justify-content: center;
    }
    .login-mobile, .email {
        width: 90%;
    }
    .areaCode {
        width: 88px;
    }
    .areaCode /deep/ .el-input__inner  {
        border: 1px solid #E1E4EA;
        border-top-left-radius: 2px;
        border-top-right-radius: 0;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 0;
        color: #303133;
        font-size: 14px;
        cursor: pointer;
    }
    .el-icon-arrow-down {
        position: absolute;
        left: 84px;
        cursor: pointer;
    }
    .phone /deep/ .el-input__inner {
        border: 1px solid #E1E4EA;
        border-left: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 2px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 2px;
    }
    /deep/ .el-input__inner {
        border-radius: 2px;
        height: 48px;
        font-size: 16px;
    }
    /deep/ .el-button {
        height: 44px;
    }
    .password, .captcha {
        text-align: center;
        padding-top: 24px;
    }
    .remember {
        text-align: center;
        padding-top: 24px;
    }
    .login-btn {
        text-align: center;
        padding-top: 40px;
        button {
            width: 90%;
        }

    }
    .login-method {
        text-align: center;
        .login-method-im, .login-method-or {
            width: 90%;
            display: inline-block;
        }
        img {
            width: 32px;
            margin: 10px;
            cursor: pointer;
        }
    }

    .popup-mask {
        position: absolute;
        height: 100vh;
        width: 100%;
        top: 0;
        background: #000;
        opacity:0.2;
        z-index: 100;
    }
    .popup-dialog {
        position: absolute;
        top: 25%;
        width: 90%;
        background: #fff;
        text-align: center;
        z-index: 200;
        left: 5%;
        border-radius: 4px;
    }
    .popup-title {
        padding: 36px;
        height: 26px;
        font-size: 18px;
        font-weight: 600;
    }
    .popup-content {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        min-height: 60px;
        margin: 8px 40px;
        word-wrap:break-word;
    }
    .popup-submit {
        height: 56px;
        line-height: 56px;
        border-top: 1px solid #eff1f7;
        color: #9AC331;
        cursor: pointer;
    }
    .forgetPwd {
        float: right;
        color: #9AC331;
        cursor: pointer;
    }
    .emailPwd {
        color: #9AC331;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        position: absolute;
        bottom: 12px;
        width: 100%;
        text-align: center;
    }
    .send, .send:hover {
        width:20%;
        float: right;
        height: 48px;
        background: #FFFFFF;
        color: #606266;
    }
}

.login-method-img {
  .btn {
    padding: 0;
    height: unset;
    border: 0;
  }
  .btn:hover {
    background: unset;
  }
}
</style>
